/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_SuccessInputs */

const vi_customer_display_success = /** @type {(inputs: Customer_Display_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã nhận thanh toán`)
};

/**

* @param {Customer_Display_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_success = /** @type {((inputs?: Customer_Display_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_success(inputs)
});